import { Accordion, Box } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledBox = styled(Box)({
  minHeight: "300px",
  borderRadius: "4px",
  border: "1px solid #d6d6d6",
  "& img": {
    maxWidth: "100%",
    height: "auto"
  },
  "& .MUIRichTextEditor-container-69": {
    margin: 0
  },
  "& #mui-rte-container > div:nth-child(2)": {
    padding: "0px 14px",
    minHeight: "190px"
  },

  "& .MuiSvgIcon-root": {
    fontSize: "1.25rem"
  }
})

export const StyledAccordion = styled(Accordion)({
  border: "none",
  "& .MuiButtonBase-root": { paddingLeft: 0 },
  "& .MuiAccordionSummary-content": { margin: 0 }
})
